/**
 * Workspace and account utility functions
 */
/**
 * Extract a domain name from a URL and capitalize it
 * @param url - The URL to extract from (with or without protocol)
 * @returns Capitalized domain name (e.g., "Google" from "google.com")
 */
function extractDomainName(url) {
    try {
        const urlObj = new URL(url.startsWith('http') ? url : `https://${url}`);
        const hostname = urlObj.hostname.replace(/^www\./, '');
        const domainName = hostname.split('.')[0];
        // Replace dashes with spaces and capitalize each word
        return domainName
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
    catch {
        return '';
    }
}
/**
 * Generate a URL-safe slug from text
 * @param text - The text to convert to a slug
 * @returns Lowercase slug with hyphens (e.g., "my-company" from "My Company!")
 */
function generateSlug(text) {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
/**
 * Clean and normalize an account slug
 * @param slug - The slug to clean
 * @returns Cleaned slug with only alphanumeric characters and hyphens
 */
function cleanAccountSlug(slug) {
    return slug.trim().replaceAll(/[^a-zA-Z0-9-]{1,}/g, '-');
}

export { cleanAccountSlug, extractDomainName, generateSlug };
//# sourceMappingURL=workspace.esm.js.map
